<script>
import button from "@/mixins/toolBar/button";
// import axios from "axios";

export default {
  name: "DownloadButton",
  mixins: [button],
  props: {
    image: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      name: "Download",
      icon: "fa-download",
      include: {
        image: true,
        coco: true
      }
    };
  },
  methods: {
    downloadURI(uri, exportName) {
      let link = document.createElement("a");
      link.href = uri;
      link.download = exportName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    download() {
      this.downloadURI(
        "/api/image/" + this.image.id + "?asAttachment=true",
        this.image.file_name
      );
      if(this.dicomPath != '') {
        this.downloadURI(
          "/api/image/" + this.image.id + "?asAttachment=true&asDicom=true",
          this.image.file_name+'.dcm'
        );
      }

      // console.log("image.file_name: " + this.image.file_name);  
      // console.log("image.predicted: " + this.image.predicted);
      if(this.image.predicted == true){
        for (const [product_code, res] of Object.entries(this.image.results)) {
          this.downloadURI(
            "/api/resultAI/" + res.id + "?asAttachment=true",
            this.image.file_name + product_code + ".png"
          );
          this.downloadURI(
            "/api/resultAI/" + res.id + "?asAttachment=true&asJson=true",
            this.image.file_name + product_code + ".json"
          )
        }
      }
    },

    execute() {
      this.$parent.save(this.download);
    }
  }
};
</script>
